/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
//   'use strict'
/* global  */
(function() {
	var config = expocadfx.config;
	var txt = expocadfx.txt;
    var fxData = expocadfx.fxData;
	var FxEvent = expocadfx.fxevent;
    var util = expocadfx.util;
	var localStorage = expocadfx.localStorage;
    var elemById = expocadfx.element.elementById;
    var DataManager = expocadfx.DataManager;
    var FloorPlan = expocadfx.Floorplan;
    var PageControl = expocadfx.PageControl;
    var Favorites = expocadfx.Favorites;
    var pgSetup = expocadfx.pageSetup;
	var loadScript = expocadfx.loadScript;
	var setupHeaderFooter = expocadfx.setupHeaderFooter;
    var setupGA = expocadfx.setupGA;
    var Sales = expocadfx.Sales;

	var dataMgr = null;
    var favs = null;
    var doc = document;
    var pgCtl = null;
    var fp = null;
	
//    fxData.startTime = Date.now();
	
///////////   for external call from SalesForce   ///////////////////////////////////
    expocadfx.salesLogout = function salesLogout() {
        if( pgCtl.isSalesLoggedIn() ) {
            pgCtl.disableSales( true);
        }
    };
		// for external call from SalesForce
    expocadfx.zoomToBooth = function( numbers) {
        if( numbers !== null && numbers !== undefined && numbers !== "") {
            zoomToBoothNumbers( numbers);
        }
        else {
            console.log( "Zoom to booth called with no booth numbers   " + numbers);
        }
    };
//////////////////////////////////////////////////////////    
    // Set is XML flag if exfx.html is detected
    if(doc.baseURI.toLowerCase().includes("exfx.html")){
        config.isXML = true;
    }

    doc.addEventListener( "Loader_Ready", loaderReady);
    doc.addEventListener( "Sales_Floorplan_Loaded", null);
    dataMgr = new DataManager();
	
	function loaderReady() {
		doc.removeEventListener( "Loader_Ready", loaderReady);
		dataMgr.loadInitial( initialDataLoaded);
		util.parseQuerySting( config, fxData);
		util.parseUA( navigator.userAgent, fxData);
	}
	
    function initialDataLoaded() {           // config and options
		var fileName = "";
		var ls = localStorage.storageAvailable( "localStorage");
		var langPreference = "";
		var obj = null;
			//  load text file for selected or prefered language   CHECK localStorage !
		if( config.languages.length > 0) {
			if( ls) {
				langPreference = ls.getItem( "languagePreference");
			}
			
			obj = util.arrayFind( config.languages, "file", langPreference);
			if( obj) {
				fileName = obj.file;
				fxData.languagePreference = langPreference;
			}
			else if( config.defaultlanguage) {
				obj = util.arrayFind( config.languages, "file", config.defaultlanguage);
				if( obj) {
					fileName = obj.file;
					fxData.languagePreference = config.defaultlanguage;
				}
				else {
					fileName = config.languages[0].file;
				}
			}
			else {
				console.log( "NO Default - Get file name from first array item: " + config.languages[0].file);
				fileName = config.languages[0].file;
			}
		}
			//  load it
		doc.addEventListener( "Text_Loaded", textAvailable);
		dataMgr.loadTextFile( fileName);
		
        if( config.is3d) {
			if( config.salesMode !== "none") {
				config.is3d = false;
			}
            else if( !util.detectWebGL()) {
				console.log( "Turn 3d off ---- No WebGL Detected");
				config.is3d = false;
            }
        }
    }
	
	function textAvailable() {
		doc.removeEventListener( "Text_Loaded", textAvailable);
		
        var arVersion = config.expocadVersion.split( ".");		// needed for data change in 
        var major = parseInt( arVersion[0], 10);				//  EXPOCAD version 7.11
        var minor = parseInt( arVersion[1], 10);
        var patch = (arVersion.length > 2) ? parseInt( arVersion[2], 10) : 0;
		var logo = null;
		
        setupHeaderFooter();
		
        pgCtl = new PageControl( dataMgr);
        doResize();
		
		doc.addEventListener( "orientationchange", doResize);
        doc.addEventListener( "Favorite_Change", favChangeHandler);

		if( config.hdrLogoSource !== "") {
			logo = elemById( "logo");
            logo.onload = function() {
                logo.style.display = "block";
                adjustLayout();
            };
            logo.onerror = function() {
                console.log( "Error loading Header Logo");
                adjustLayout();
            };
			logo.src = config.hdrLogoSource;
        }
            //  Check Authorization Code
        config.authorizationKey = config.authorizationKey.replace(/\s/g, "");
        if( config.authorizationKey !== "" && config.authorizationKey !== fxData.queryAuthKey) {
            failMsg( "You are not authorized to use program at this time.");
            return;
        }
        
        // Adding Multiview sales support in 4.5.x -ANH 
        // if( config.salesMode !== "none" && config.hasMultipleViews) {
        //     config.salesMode = "none";
        //     alert( "FX Sales is not currently supported in Carousel ( multi-view) events");
        //swal("", "FX Sales is not currently supported in Carousel ( multi-view) events", "error");
        // }
		
		if( config.hasFloorPlan) {
			fp = new FloorPlan();
			if( config.is3d) {

                var path = "../util/three.min.js";

                if( config.isXML){
                    path = "three.min.js";
                }

				loadScript( path, cbThree, true);
			}
		}
		
        if( config.hasMultipleViews && config.viewName === "") {      //  Carousel/multi-view-overview
            dataMgr.loadMultiViewList();
            pageInit();
        }
        else {
            // 5.0 - Don't need to authorize since server access is required   
            //  check authorization and expiration
            if( !util.checkFile( config, doc.domain) && config.isXML) {
               failMsg( txt.FAIL_AUTH);
            }
            else if( util.checkDate( config) > 0 && config.isXML) {
                failMsg( txt.EXPIRED);
            }
            else {
                if( config.password !== "" || config.salesMode !== "none") {
                    
                    doc.addEventListener( "Last_Message_Number_Ready", lastMessageReady);
                    if(config.isXML) {
                        //pgCtl.loginRequired( config.salesMode);
                    }
                    else{
                        pgCtl.fx5Login(config.salesMode);
                    }
                }
                                
                if( major > 7 || ( major === 7 && ( minor > 11 || ( minor === 11 && patch > 0)))) {
                    //Change scale here
                    config.MULTIPLIER = 3;
                    config.DRAWING_WIDTH = config.MULTIPLIER * config.DRAWING_WIDTH;
                    config.DRAWING_HEIGHT = config.MULTIPLIER * config.DRAWING_HEIGHT;
                }
                else {
                    config.oldVersion = true;
                }
				if( !config.is3d || config.salesMode !== "none") {
					loadRemainingData();
				}
            }
        }
    }

    function lastMessageReady(){
        pgCtl.loginRequired( config.salesMode);
    }
	
	function cbThree( success) {
		if( !success) {
			console.log( "THREE.js DID NO LOAD!");
			config.is3d = false;
		}
		loadRemainingData();
	}
    
    function failMsg( msg)  {
        var divMsg = doc.createElement( "div");
        var msgArea = doc.createElement( "div");
        var msgText = doc.createElement( "p");
        
        divMsg.setAttribute( "class", "modalDialog");
        msgArea.className = "msgArea";
        msgText.className = "failed";
        
        msgText.textContent = msg;
        
        divMsg.appendChild( msgArea);
        msgArea.appendChild( msgText);
        elemById( "appContent").appendChild(divMsg);
    }
    
    function loadRemainingData() {
        dataMgr.loadAllData( dataLoaded);
		doc.addEventListener( "Technical_Layer_Ready", setupLayesMenu);
        pageInit();
    }
	
	function setupLayesMenu() {
		doc.removeEventListener( "Technical_Layer_Ready", setupLayesMenu);
		pgSetup.addTechMenu( fp.is2d());
	}
    
    function dataLoaded() {
//        fp = new FloorPlan();
        fp.init();
        pgCtl.setFloorPlan( fp);
        
        doc.addEventListener( "Floor_Plan_Ready", floorPlanReadyHandler);
    }
	
	function floorPlanReadyHandler() {
		var ar = [];
		var iAmHereLabel = txt.I_AM_HERE;
		
		doc.removeEventListener( "Floor_Plan_Ready", floorPlanReadyHandler);
		
		if( !config.bHideAvailableList) {
			checkAvailableBooth();
		}

		if( fxData.queryIndex !== "") {       //  check at initialization in floorplan ??
			fp.zoomToBoothIndex( fxData.queryIndex, true);
		}
		else if( fxData.queryBooths !== "") {
			zoomToBoothNumbers( fxData.queryBooths);
		}
		else if( fxData.queryCoord !== "") {
			ar = fxData.queryCoord.split( ",");

			if( ar.length === 3 && ar[2] !== "") {
                iAmHereLabel = ar[2];
            }

			fp.zoomToIAmHere( ar[0], ar[1], iAmHereLabel);
		}
		pgCtl.initPeriodicFunctions();
		
		if( fxData.status.favoritesReady) {  //  && not already marked ??
			fp.markFavorites();
		}

		if( fxData.queryExhibitor) {  //??  open exhibitor info dialog ??  "Exhibitor_Selected"
			var obj = null;
			var displayExhibitor = util.arrayFind(fxData.displayExhibitors, "name", fxData.queryExhibitor);

			if( displayExhibitor) {
				obj = {
					exhibitorIndex : displayExhibitor.exhibIndex,
					boothIndex : displayExhibitor.arBoothIndexes.join( ",")
				};
				doc.dispatchEvent( new FxEvent( "Exhibitor_Selected", obj));
			}
        }
        if( config.defaultListWindowOpen) {
			util.addClass( elemById( "listWindow"), "nav-begin");
		}
		if(config.defaultListWindowOpen){
			util.addClass( elemById( "listWindow"), "nav-open");
        }
        if(config.defaultListWindowOpen){
            window.setTimeout(function(){
                util.removeClass( elemById( "listWindow"), "nav-begin");
            }, 400)
        }
		if( !config.defaultListWindowOpen) {
			util.addClass( elemById( "listWindow"), "nav-closed");
		}
		if( fxData.gaAccount === null) {
			dataMgr.loadGoogleAccount( checkGoogle);
		}
		else if( fxData.gaAccount !== "") {
			setupGA( fxData.gaAccount);
		}
    }

	function checkGoogle( success, result) {
		var acct = "";
		if( success) {
			acct = result.getElementsByTagName( "Account")[0];
			if( acct && acct.textContent !== "") {
				setupGA( acct.textContent);
			}
		}
	}
	
    function zoomToBoothNumbers( numbers) {
        var arIndexes = [];
        var arBooths = String( numbers).split( ",");
        var idx = -1;
        var i = 0;
        
        for( i = 0; i < arBooths.length; i++) {
            idx = util.findBoothIndex( arBooths[i], fxData.booths);
            if( idx !== -1) {
                arIndexes.push( idx);
            }
        }
        if( arIndexes.length > 0) {
            fp.zoomToBoothIndex( arIndexes.join( ","), true);
        }
    }
    
    function checkAvailableBooth() {
        doc.removeEventListener( "Floor_Plan_Ready", checkAvailableBooth);
        if( fxData.numAvailableBooths > 0) {
            pgCtl.addAvailableBoothPage();
        }
        else {
            pgSetup.removeAvailableBoothButton();
        }
    }
    
    function checkFavorites() {
		if( config.hasMultipleViews) {
			favs.validate( fxData.eventBooths);
			if( !config.hasFloorPlan) {
				dataMgr.parseShowExhibitors();
			}
		}
		else {
			favs.validate( fxData.exhibitors);
		}
		
		fxData.status.favoritesReady = true;
		if( fp !== null && fp !== undefined) {
			fp.markFavorites();
		}
    }
    
    function favChangeHandler( evt) {
        if( evt.data.fav) {
            favs.save( evt.data.boothNumber, evt.data.exhId);
			
            if( evt.data.local) {
                fp.tagBooth( evt.data.boothIndex);
            }
        }
        else {
            favs.remove( evt.data.boothNumber, evt.data.exhId);
            if( evt.data.local) {
                fp.clearBooth( "favorite", evt.data.boothIndex);
            }
        }
    }

    function pageInit() {
        pgSetup.initializePages();
        pgCtl.initialize(); 
        
        doc.addEventListener( "Size_Change", adjustLayout);
        doc.addEventListener( "Banner_Added", function( evt) {
            pgCtl.handleAdBanner( evt.data);
            adjustLayout();
        });

        adjustLayout();

        favs = new Favorites();
        favs.init( config.eventName);
        
        doc.addEventListener( "Ready_To_Validate_Favorites", function() {
            fxData.status.exhibitorsReady = true;
            checkFavorites();
        });
    }

        //  need to call this after logo, social options, ads are loaded !
    function adjustLayout() {
        if ( !config.isXML && !config.noNav){
            var check = elemById("directoryNav");
            if(!check){
              generateNav();
            }
            
            var headerHeight = elemById("directoryNav").offsetHeight;
            elemById("appContent").style.top = headerHeight + "px";
        }
        else{
            //console.log(config.isXML)
            //console.log(config.noNav)  

            var headerHeight = elemById( "mainHeader").offsetHeight;
        }
        
        var appHeight = fxData.viewportHeight - headerHeight - elemById( "ftr").offsetHeight - 1;
		
        elemById("appContent").style.height = appHeight + "px";
        
        setContainerSize( appHeight);
        fxData.headerHeight = headerHeight + 1;
        
        if( fxData.headerHeight < 48) {
            elemById( "control1").style.top = ( 60 - fxData.headerHeight) + "px";
        }
        else {
            elemById( "control1").style.top = "10px";
        }
    }

    function generateNav(){
        var nav = document.createElement('div');
        var search = document.createElement('nav');
        var body = document.getElementsByTagName("body")[0];

        body.appendChild(nav); 
        nav.appendChild(search)
        nav.setAttribute('id', 'directoryNav');
        nav.setAttribute('class', 'navbar-header fixed-top');
        search.setAttribute('id', 'searchBar');
        search.setAttribute('class', 'navbar navbar-expand-lg');
        
        search.innerHTML = '<a class="logo nav-details-open pull-left"><img class="img-fluid" src="../../Images/EXPOCADLogoNew.png" style="max-width:150px;" /></a>' +         
        '<button class="navbar-toggler" id="navToggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">' +
        '<i id="navBars" class="fa fa-bars"></i>' +
        '</button>' +
        '<div class="collapse navbar-collapse" id="navbarSupportedContent">' +
        '<ul class="nav navbar-toolbar mr-auto navbar-toolbar-left">' +
        '<li><i class="fa fa-expand" id="barNone" value="click to toggle fullscreen" onclick="toggleFullScreen()"></i></li>' +
        '</ul>' +
        '<ul class="nav navbar-toolbar" id="dirNavbarNav"></ul>' +
        '<ul class="nav navbar-toolbar ml-auto navbar-toolbar-right">' +
        '<a id="directoryLogin"><button class="btn-expo">Login</button></a>' +
        '</ul>' +
        '<ul class="super-right">' +
        '</ul>' +
        '</div>'
    }

    function setContainerSize( height) {
        fxData.pageHeight = height - fxData.initialAccordionHeight + "px";
           //allow for seach header
        elemById( "exhGrid").style.height = (height - fxData.initialAccordionHeight - 36) + "px";
		elemById( "boothGrid").style.height = (height - fxData.initialAccordionHeight - 36) + "px";
        
        if( fxData.smallLayout) {
            elemById( "exhGrid").style.width = fxData.viewportWidth - 1 + "px";
			elemById( "boothGrid").style.width = fxData.viewportWidth - 1 + "px";
        }
        else {
            elemById( "exhGrid").style.width = "416px";
			elemById( "boothGrid").style.width = "416px";
        }
        
        elemById( "viewContent").style.height = fxData.pageHeight;  //  ?????
        elemById( "floorplan").style.width = fxData.viewportWidth;
        
        if( fp) {
            fp.windowResizeHandler( fxData.viewportWidth, height);
        }
        
        if( fxData.grid !== null) {
            fxData.grid.resizeCanvas();
        }
        pgSetup.resize();
        pgCtl.resize();
    }

    function doResize() {
        fxData.viewportWidth = doc.documentElement.clientWidth || doc.body.clientWidth;
        fxData.viewportHeight = doc.documentElement.clientHeight || doc.body.clientHeight;
        fxData.smallLayout = ( fxData.viewportWidth < 750);
        adjustLayout();
    }
    window.onresize = function() {
        var newWidth = window.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
        var newHeigth = window.innerHeight || doc.documentElement.clientHeight ||  doc.body.clientHeight;
        
        var timerId;
        if( newWidth === fxData.viewportWidth && newHeigth === fxData.viewportHeight) {
            
            clearTimeout( timerId);
            timerId = setTimeout( doResize(), 100);
        }
        else {
            doResize();
        }
    };
}());
